import { render, staticRenderFns } from "./ManagementSurveyEditQuestionWidget.vue?vue&type=template&id=2b126439&"
import script from "./ManagementSurveyEditQuestionWidget.vue?vue&type=script&lang=js&"
export * from "./ManagementSurveyEditQuestionWidget.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/themes/default/management.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports